import { ICompany } from 'app/shared/model/company.model';
import { Pageable } from './pageable.model';

/*
import { ITruckImplement } from 'app/shared/model/truck-implement.model';
import { ICompany } from 'app/shared/model/company.model';

// GENERATED BY JHIPSTER
export interface IVirtualCoupling {
  id?: number;
  truck?: ITruckImplement;
  implement?: ITruckImplement;
  implement2?: ITruckImplement | null;
  implement3?: ITruckImplement | null;
  implement4?: ITruckImplement | null;
  implement5?: ITruckImplement | null;
  implement6?: ITruckImplement | null;
  company?: ICompany | null;
}

export const defaultValue: Readonly<IVirtualCoupling> = {};
*/

export interface IVirtualCoupling {
  id?: number;
  truck?: string;
  implement?: string;
  implement2?: string | null;
  implement3?: string | null;
  implement4?: string | null;
  implement5?: string | null;
  implement6?: string | null;
  company?: ICompany | null;
}

export interface VirtualCouplingResponse {
  content: IVirtualCoupling[];
  pageable: Pageable;
  totalElements: number;
  totalPages: number;
  last: boolean;
  sort: {
    sorted: boolean;
    unsorted: boolean;
    empty: boolean;
  };
  first: boolean;
  number: number;
  numberOfElements: number;
  size: number;
  empty: boolean;
}

export const defaultValue: Readonly<IVirtualCoupling> = {};
